import {FormControlField} from '../FormField';
import {PasswordLevelCnil} from '@app/components/PasswordLevel';
import {useTranslation} from '@app/hooks/useTranslation';
import {usePasswordValidator} from '@app/hooks/useValidators';
import type {FieldProps} from '../FormField';
import type {PasswordSchema} from '@app/hooks/useSchema';
import type {BoxProps} from '@tempo/core';
import {PasswordInput} from '@tempo/core';
import {useField} from 'formik';

export type PasswordFieldProps = FieldProps<string> &
	PasswordSchema & {
		showLevel?: boolean;
	};
export const PasswordField: React.FC<PasswordFieldProps & BoxProps> = ({
	context,
	showLevel = false,
	...props
}) => {
	const [pwdValidator] = usePasswordValidator({context});
	const t = useTranslation();
	const [{value}] = useField<string>(props.name);
	return (
		<FormControlField
			validate={pwdValidator}
			as={PasswordInput}
			label={t('common.label_password')}
			{...props}
		>
			{showLevel && <PasswordLevelCnil password={value} />}
		</FormControlField>
	);
};
